// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g-root {
  --color-formula-dimension: var(--g-color-text-positive);
  --color-formula-measure: var(--g-color-text-info);
  --color-field-error: var(--g-color-base-danger-heavy);
}

.field-info {
  display: flex;
  align-items: center;
  margin-right: 16px;
}
.field-info__container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.field-info__title {
  text-overflow: ellipsis;
  overflow: hidden;
}
.field-info__icon {
  margin-right: 5px;
  flex-shrink: 0;
}
.field-info__icon_parameter {
  color: var(--g-color-text-utility);
}
.field-info__icon_measure {
  color: var(--color-formula-measure);
}
.field-info__icon_dimension {
  color: var(--color-formula-dimension);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/styles/variables.scss","webpack://./src/ui/units/wizard/components/Dialogs/DialogColumnSettings/components/FieldInfo/FieldInfo.scss"],"names":[],"mappings":"AASA;EALI,uDAAA;EACA,iDAAA;EACA,qDAAA;ACFJ;;AAFA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAKJ;AAHI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAKR;AAFI;EACI,uBAAA;EACA,gBAAA;AAIR;AADI;EACI,iBAAA;EACA,cAAA;AAGR;AADQ;EACI,kCAAA;AAGZ;AAAQ;EACI,mCAAA;AAEZ;AACQ;EACI,qCAAA;AACZ","sourcesContent":[null,".g-root {\n  --color-formula-dimension: var(--g-color-text-positive);\n  --color-formula-measure: var(--g-color-text-info);\n  --color-field-error: var(--g-color-base-danger-heavy);\n}\n\n.field-info {\n  display: flex;\n  align-items: center;\n  margin-right: 16px;\n}\n.field-info__container {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n}\n.field-info__title {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.field-info__icon {\n  margin-right: 5px;\n  flex-shrink: 0;\n}\n.field-info__icon_parameter {\n  color: var(--g-color-text-utility);\n}\n.field-info__icon_measure {\n  color: var(--color-formula-measure);\n}\n.field-info__icon_dimension {\n  color: var(--color-formula-dimension);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
